import productService from 'services/ProductService';
import Grid from 'components/atoms/Grid';
import Select from 'components/atoms/Select';
import Field from 'components/molecules/Field';
import Form, { useForm } from 'components/molecules/Form';
import { useState } from 'react';
import { useMemo } from 'react';
import Button from 'components/atoms/Button';
import { useContext } from 'react';
import { AuthContext } from 'context/authContext';
import Toast from 'components/molecules/Toast';

const DuplicateProduct = ({ onClose }) => {
  const [form] = useForm();
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState({
    page: 1,
    itemsPerPage: 10,
    searchText: '',
    startDate: '',
    endDate: '',
    filterText: '',
    filterCategory: '',
  });
  const { refetch, hasPermission } = useContext(AuthContext);

  const { products_data, products_loading } = productService.GetAllProducts(searchQuery, refetch);
  const productsOpts = useMemo(() => {
    return products_data?.products?.map(product => ({
      label: product?.title,
      value: product?._id,
    }));
  }, [products_data]);

  async function onSubmit(e) {
    const payload = {
      productId: e?.product?.value,
      title: e?.title,
      sku: e?.sku,
      slug: e?.slug,
    };
    try {
      setLoading(true);
      const res = await productService.duplicateProduct(payload);

      if (res?.success) {
        Toast({
          message: 'Product duplicated successfully',
          type: 'success',
        });
        refetch();
        onClose();
      }
    } catch (ex) {
      Toast({
        type: 'error',
        message: ex.message,
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <Form form={form} onSubmit={onSubmit}>
      <Grid
        xs={1}
        lg={2}
        colGap={20}
        css={`
          align-items: center;
        `}>
        <Form.Item
          sm
          options={productsOpts}
          isSearchable
          name="product"
          label="Product"
          placeholder="Select Product"
          hideSelectedOptions={false}
          closeMenuOnSelect={true}
          rules={[{ required: false, message: 'Select atleast one product' }]}>
          <Select />
        </Form.Item>
        <Form.Item
          sm
          type="text"
          label="Title"
          name="title"
          placeholder="Post Title"
          rules={[{ required: true, message: 'Please enter post title' }]}>
          <Field />
        </Form.Item>
        <Form.Item
          sm
          type="text"
          label="SKU"
          name="sku"
          placeholder="SKU"
          rules={[{ required: true, message: 'Please enter SKU' }]}>
          <Field />
        </Form.Item>
        <Form.Item
          sm
          type="slug"
          label="Slug"
          name="slug"
          placeholder="Slug"
          rules={[{ required: true, message: 'Please enter slug' }]}>
          <Field />
        </Form.Item>
      </Grid>
      <Button loading={loading} type="primary" htmlType="submit" style={{ margin: '0 auto' }}>
        Submit
      </Button>
    </Form>
  );
};

export default DuplicateProduct;
